"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseRequestPositionDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const IsNullable_1 = require("../../transformation/IsNullable");
const PolymorphSupertype_1 = require("../../transformation/PolymorphSupertype");
const RequestCommentDTO_1 = require("./RequestCommentDTO");
let BaseRequestPositionDTO = class BaseRequestPositionDTO {
};
exports.BaseRequestPositionDTO = BaseRequestPositionDTO;
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, IsNullable_1.IsNullable)(),
    __metadata("design:type", String)
], BaseRequestPositionDTO.prototype, "priceUnitId", void 0);
__decorate([
    (0, IsNullable_1.IsNullable)(),
    (0, class_validator_1.IsNumber)({ allowNaN: false, allowInfinity: false, maxDecimalPlaces: 3 }),
    (0, class_validator_1.IsPositive)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Number)
], BaseRequestPositionDTO.prototype, "estimatedAmount", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], BaseRequestPositionDTO.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, IsNullable_1.IsNullable)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], BaseRequestPositionDTO.prototype, "deadline", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, IsNullable_1.IsNullable)(),
    (0, class_transformer_1.Type)(() => Boolean),
    __metadata("design:type", Boolean)
], BaseRequestPositionDTO.prototype, "expressPosition", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => RequestCommentDTO_1.RequestCommentDTO),
    __metadata("design:type", RequestCommentDTO_1.RequestCommentDTO)
], BaseRequestPositionDTO.prototype, "comment", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsUUID)(undefined, { each: true }),
    __metadata("design:type", Array)
], BaseRequestPositionDTO.prototype, "resourceIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsUUID)(undefined, { each: true }),
    __metadata("design:type", Array)
], BaseRequestPositionDTO.prototype, "requiredPositionIds", void 0);
exports.BaseRequestPositionDTO = BaseRequestPositionDTO = __decorate([
    (0, PolymorphSupertype_1.PolymorphSupertype)('positionType')
], BaseRequestPositionDTO);
